// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1f18n","dragIcon":"Choice_dragIcon__3g5E-","left":"Choice_left__kmetY","input":"Choice_input__3e_Sc"};